module.exports = __webpack_public_path__ + "2be661507b98ad274b933e2b068b575e.svg";